export default __webpack_public_path__ + "static/media/upload.ea952651.svg";